//URL
import configData from "../../../config.json";
import axios, { AxiosRequestConfig } from 'axios'
import InputFileUpload from 'components/Varios/InputFileUpload'
import React, { useEffect, useMemo, useState } from 'react'
import { Modal, ModalBody, ModalHeader, Container, Col, Row, FormGroup, Label, Button } from 'reactstrap'
import { DatosVistaPrevia } from './AnalistaAdministraSolicitudesCertificados'
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { authenticationService } from "services/authentication.service";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import Cargando from "components/Varios/Cargando";
import { SolicitudCertificado } from "components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados";
import SelectItem from "components/Varios/select";
import IconCloseModal from "components/Varios/Modals/IconCloseModal";

type propsModalSubirCertificado = {
    show: boolean,
    onClose: () => void,
    toogle: () => void,
    datos: DatosVistaPrevia,
    handleSubirCertificado: (datos: SolicitudCertificado) => void
    // opcionesFirma: { value: string, label: string }[]
    opcionFirma: number,
    handleSelectChange: (value: string, name: string) => void
}
export const ModalSubirCertificado = (props: propsModalSubirCertificado) => {
    const [fileCertificado, setfileCertificado] = useState<File>()
    const [loadingSubirCertificado, setloadingSubirCertificado] = useState<boolean>(false)
    const [mensajeError, setmensajeError] = useState<string>("")
    const [elementoError, setelementoError] = useState<HTMLElement>()
    function handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        setfileCertificado(fileInfo.file)
    }

    async function SubirCertificado(datos: DatosVistaPrevia) {
        setloadingSubirCertificado(true)
        var currentUser: UserData = authenticationService.currentUserValue;

        const formData = new FormData();
        if (fileCertificado) {
            formData.append("files", fileCertificado, fileCertificado.name);
            formData.append("idSolicitud", datos.idsolicitud.toString());
            formData.append("Personafirma", props.opcionFirma.toString());
            formData.append("concurrencyToken", datos.concurrencyToken?.toString() ?? "");
        }

        let instance = axios.create({ baseURL: configData.SERVER_URL });


        let options: AxiosRequestConfig = {
            url: `GenerarCertificados/SubirCertificado`,
            data: formData,
            method: "POST",
            responseType: "json",
            headers: {
                Authorization: `KEYESPOL ${currentUser?.token}`
            }
        };
        try {
            const respuesta = await instance.request<any>(options)
                .then((response) => {
                    var datos: SolicitudCertificado = response.data;
                    props.handleSubirCertificado(datos)
                })
                .catch((error) => {
                    var error_any: any = error;
                    var status_number = handle_error(error_any);
                    var mensaje_error: string = "Error desconocido. Intente más tarde";
                    switch (status_number) {
                        case 500:
                            mensaje_error = "Error inesperado. Intente más tarde"
                            break;
                        case 0:
                            mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                            break;
                        case 401:
                            mensaje_error = "No está autorizado a realizar esta acción";
                            break;

                        case 409:
                            mensaje_error = error_any.response.data;
                            break;
                        default:
                            break;
                    }
                    setmensajeError(mensaje_error)
                });

        } catch (error) {
            var error_any: any = error;
            var status_number = handle_error(error_any);
            var mensaje_error: string = "Error desconocido. Intente más tarde";
            switch (status_number) {
                case 500:
                    mensaje_error = "Error inesperado. Intente más tarde"
                    break;
                case 0:
                    mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                    break;

                case 401:
                    mensaje_error = "No está autorizado a realizar esta acción";
                    break;

                case 409:
                    mensaje_error = error_any.response.data;
                    break;

                default:
                    break;
            }
            setmensajeError(mensaje_error)
        }
        setloadingSubirCertificado(false)

    }

    useEffect(() => {
        if (mensajeError) {

            var elemento_error: any = (
                <div key="uniqueErrorElement 1">
                    {mensajeError}
                </div>
            )

            setelementoError(elemento_error);
        }
    }, [mensajeError])

    function CerrarModal() {
        setfileCertificado(undefined);
        setloadingSubirCertificado(false)
        setmensajeError("")
        setelementoError(undefined)
        props.onClose();
        document.body.classList.remove('modal-open')
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])

    return (

        <Modal

            isOpen={props.show}
            scrollable={false}
            size={"md "}
            fullscreen={"md"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={BotonCerrar}>
                Subir certificado
            </ModalHeader>
            <ModalBody>
                {loadingSubirCertificado &&
                    <Cargando
                        mensaje="Subiendo Certificado"
                    />
                }
                {
                    !loadingSubirCertificado &&
                    <div>

                        <Container>
                            <form>
                                <Row form>
                                    <Col md={12}>
                                        <div>
                                            <label> <span className='font-weight-bold'>{props.datos.nombreCertificado + " "}</span>  para {props.datos.nombrePersona}</label>
                                        </div>
                                    </Col>
                                </Row>
                                <Row form>
                                    {props.opcionFirma > 0 &&
                                        <Col md={12}>
                                            <FormGroup>
                                                <InputFileUpload
                                                    icon="upload"
                                                    onChange={handleFileUploadChange}
                                                    name="SC"
                                                    placeholder={"Subir Certificado"}
                                                    tooltipmessage="El archivo se subirá al dar clic en el botón Enviar"
                                                />

                                            </FormGroup>
                                        </Col>
                                    }

                                </Row>
                                <div>
                                    {elementoError}
                                </div>

                                {
                                    fileCertificado &&
                                    <Row form>
                                        <Col>
                                            <Button
                                                onClick={() => SubirCertificado(props.datos)}
                                            >
                                                Enviar
                                            </Button>
                                        </Col>
                                    </Row>
                                }
                            </form>

                        </Container>
                    </div>
                }


            </ModalBody>

        </Modal>
    )
}

